import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { UrlService } from '../../services/url.service';

declare const moment: any;

@Component({
    selector: 'daily-reports-filter',
    templateUrl: './daily-reports-filter.component.html',
    styleUrls: ['./daily-reports-filter.component.scss']
})
export class DailyReportsFilterComponent implements OnInit {
    showDropdown = false;
    startDate = '';
    endDate = '';
    @ViewChild('closedCheckbox') closed: ElementRef;
    @ViewChild('draftCheckbox') draft: ElementRef;
    @ViewChild('startDateCheckbox') startDateCheckbox: ElementRef;
    @ViewChild('endDateCheckbox') endDateCheckbox: ElementRef;

    constructor(private urlService: UrlService) { }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {
            const status = this.urlService.queryParams['status'];
            if (status) {
                this.closed.nativeElement.checked = status.indexOf('closed') !== -1;
                this.draft.nativeElement.checked = status.indexOf('draft') !== -1;
            } else {
                this.closed.nativeElement.checked = false;
                this.draft.nativeElement.checked = false;
            }

            const periodStartDate = this.urlService.queryParams['periodStartDate'];
            const periodEndDate = this.urlService.queryParams['periodEndDate'];
            if(periodStartDate)
                this.startDate = moment(periodStartDate)._d;
            if(periodEndDate)
                this.endDate = moment(periodEndDate).add(-1, 'day')._d;
        });
    }

    changeFilter() {
        const closedValue = this.closed.nativeElement.checked;
        const draftValue = this.draft.nativeElement.checked;

        if (!closedValue && !draftValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (closedValue) status += 'closed,';
            if (draftValue) status += 'draft,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }

        if (!this.startDate && !this.endDate) {
            this.urlService.queryParams['periodStartDate'] = null;
            this.urlService.queryParams['periodEndDate'] = null;
        } else {
            if (this.startDate)
                this.urlService.queryParams['periodStartDate'] = moment(this.startDate).format('YYYY-MM-DD');
            if (this.endDate)
                this.urlService.queryParams['periodEndDate'] = moment(this.endDate).add(1, 'day').format('YYYY-MM-DD');
        }
        this.urlService.setQueryParams(null, 1);
    }

    onStartDateChange() {
        if(this.startDate > this.endDate) {
            this.endDate = '';
            this.urlService.queryParams['periodEndDate'] = null;
        }
    }

    clearDates() {
        this.startDate = '';
        this.endDate = '';
        this.changeFilter();
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('daily-reports-filter') &&
            !targetElement.closest('.cdk-overlay-container') &&
            !targetElement.closest('.mat-calendar-body-cell-content'))
            this.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/daily-reports-filter/daily-reports-filter.component.ts